import {getWorkspaceFromUri} from './getWorkspaceFromUri';

const CARVAGO_WORKSPACE = 'carvago';

/**
 * Carvago tests on DEV and STAGE in the `caraudit` workspace. Production keeps the features in
 * `carvago` only, so a production `caraudit` tenant and the bare `caraudit.app` host stay generic.
 */
const CARVAGO_TEST_WORKSPACE = 'caraudit';

// An empty or unknown ENV_TYPE keeps the test workspace closed.
const CARVAGO_TEST_ENV_TYPES: ReadonlyArray<string> = ['dev', 'stage'];

/**
 * Carvago-only certificate features: the inspection equipment PDF, the formatted `ca-report`
 * comment and the static History check section. DMS applies the same equipment PDF rule in
 * `libs/dms/teas/src/components/VehicleInspection/utils/isCarvagoWorkspace.ts` (the app cannot
 * import `@dms/*`); keep the two in sync.
 */
export function isCarvagoWorkspace() {
  const {workspace} = getWorkspaceFromUri();

  if (workspace === CARVAGO_WORKSPACE) {
    return true;
  }

  return (
    workspace === CARVAGO_TEST_WORKSPACE &&
    CARVAGO_TEST_ENV_TYPES.includes(process.env.ENV_TYPE ?? '')
  );
}
